import React, { Component } from "react";
import MaterialTableOrig, {
    MaterialTableProps,
    // Localization as MaterialTableLocs
} from "material-table";
import iconsDefault from "./icons";
import { MentorLocalizations } from "../../../Shared/sharedTypes";
// import { Localizations } from "../../types";

interface MyMaterialTableProps<RowData extends object> extends MaterialTableProps<RowData> {
    forwardedRef?: any;
    localizations: MentorLocalizations;
}

export default class MaterialTable<RowData extends object> extends Component<MyMaterialTableProps<RowData>> {
    // constructor(props: MyMaterialTableProps<RowData>) {
    //     super(props);
    // }

    render() {
        let { icons, forwardedRef, ...rest } = this.props;

        var localizations = this.props.localizations;

        var locs = {
            ...rest.localization,
            body: {
                emptyDataSource: localizations.noRecordsToDisplay,
            },
            grouping: {
                placeholder: `Drag [${rest.columns
                    .filter((c) => c.grouping)
                    .map((c) => c.title)
                    .join(",")}] here to group by it`,
            },
            header: { actions: localizations.actions },
            toolbar: { searchPlaceholder: localizations.search },
            pagination: {
                lastTooltip: localizations.lastPage,
                nextTooltip: localizations.nextPage,
                previousTooltip: localizations.previousPage,
                firstTooltip: localizations.firstPage,
                labelRowsSelect: localizations.rows,
                labelDisplayedRows: "{from}-{to} " + localizations.of + " {count}",
            },
        } as any;

        return (
            <MaterialTableOrig
                ref={forwardedRef}
                icons={iconsDefault}
                localization={locs}
                {...rest}
            ></MaterialTableOrig>
        );
    }
}
